function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1809 0.315952C12.7999 -0.0895934 12.1647 -0.107455 11.7623 0.278131L5.35604 6.41104L2.30043 3.24413C1.91342 2.84332 1.27889 2.83453 0.881489 3.22524C0.484429 3.61556 0.476065 4.25677 0.862731 4.65758L4.60911 8.54032C4.80544 8.74393 5.06636 8.84656 5.32795 8.84656C5.57616 8.84656 5.82436 8.75403 6.01871 8.56868L13.1435 1.748C13.5455 1.36305 13.5626 0.721839 13.1809 0.315952Z",
  fill: "white"
});

var SvgWhiteTick = function SvgWhiteTick(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhiteTick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/white-tick.37dd0349.svg";
export { ForwardRef as ReactComponent };